import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm4-7h-3V2h-2v2H8V2H6v2H3v18h18V4zm-2 16H5V9h14v11z"
}), 'DateRangeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DateRangeSharp.js
// module id = 3056
// module chunks = 2